import React from 'react'
import '../home.css';
import SEO from '../SEO.js';

const Vessel = () => {
    const secondaryFontStyle = { fontFamily: "'Raleway', sans-serif" };
    const museoStyle = { fontFamily: "'MuseoModerno', cursive" };

    return (
        <div>
                <SEO
                    title="Vessel"
                    description="Vessel is a handheld object that unlocks AI agents on a machine, exploring what physical attachment to AI could look like. A project by Lord Crawford."
                    path="/vessel"
                />
                <div className="text-[4vw] ml-[3.5%] mt-[2%] space-y-[-2vw] invisible title-spacer" aria-hidden="true"><div>Lord</div><div>Crawford</div></div>
                <div className='pb-[6vw] px-[3.5%]'>
                    <div className='mt-[12%] md:mt-[6%] max-w-[860px]'>
                        <div className='flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-14'>
                            <h2 style={museoStyle} className="text-[5.5vw] md:text-[2.6vw] text-emerald-600 font-normal leading-[1.05]">
                                VESSEL
                            </h2>
                        </div>

                        <p className="mt-10 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                            <b>What does physical attachment to AI look like?</b>
                            <br/><br/>
                            We've built distinct relationships to technology through objects — the internet through laptops, social media through our phones, music through headphones and speakers, movies through TV screens and theatres. However, this kind of relationship doesn’t exist yet for artificial intelligence. Robots may be the answer, but they’re rather uncomfortable and don’t resonate with the human experience. In this project, I explore what it could look like to develop an organic and integrated relationship to AI.
                            <br/><br/>
                            I’m calling it Vessel. A vessel is a unique handheld object that unlocks an AI agent on a machine, such as a computer. Each vessel has a highly distinctive pattern that makes it function as a key. In short, you can bring a vessel near your computer, the computer will detect the vessel’s pattern, then load the corresponding agent ready for your request. From here, you can perform complex tasks such as computer control, product shopping, and voice assistance.
                            <br/><br/>
                            Vessel isn’t just a key though. Each one has its own rulebook detailing what actions the agent can take, which data it can use, and custom guardrails it must follow. With Vessel, I’m proposing a new protocol where physical products can govern agentic use.
                        </p>

                        <div className="mt-10 border-t border-stone-200" />

                        <div className="mt-10">
                            <h2 className="text-[22px] md:text-[26px] font-normal text-black">Specifications</h2>
                            <div style={secondaryFontStyle} className="mt-3 text-[16px] md:text-[17px] leading-relaxed text-stone-700 font-raleway">
                                <p><b>Dates:</b> 2026 - Ongoing</p>
                                <p><b>Tools Used:</b> Python, Javascript, HTML/CSS, OpenCV, Tensorflow, OpenRouter</p>
                                <p><b>Role:</b> Sole Developer and Designer</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    )
}

export default Vessel

